import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  toasts as toastHelpers,
  urls
} from '../helpers';
import { NavDropdown, ListGroupItem } from 'react-bootstrap';

export class RecentToastsComponent extends Component {
  static propTypes = {
    recentToasts: PropTypes.array.isRequired,
    deleteToast: PropTypes.func.isRequired
  };

  render() {
    return (
      <NavDropdown
        title={
          <div className="pull-left">
            <img className="thumbnail-image"
              src={this.props.recentToasts.length === 0 ?
                urls.TOASTS_UNAVAILABLE_SRC : urls.TOASTS_AVAILABLE_SRC}
              height= "25"
            />
            ({this.props.recentToasts.length})
          </div>
        }
        id={'recent-toasts'}
      >
        <div style={{ 'paddingRight': '2px', 'paddingLeft': '2px' }}>
          {this.props.recentToasts.length === 0 ?
            emptyToasts() : renderToasts(this.props.recentToasts, this.props.deleteToast)}
        </div>
      </NavDropdown>
    );
  }
}

const renderToasts = (recentToasts, deleteToast) =>
  recentToasts.map((toast, index) => {
    return (
      <ListGroupItem
        key={index}
        id={index}
        bsStyle={toastHelpers.toastrTypeToStyle(toast.toastType)}
      >
        <div style={{ width: '300px', 'paddingTop': '1px' }}>
          <button key={index} id={index} type="button"
            className="close" aria-label="Close"
            onClick={() => deleteToast(toast)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h5> {toast.toastType.toUpperCase()} </h5>
          {toast.message} <br />
          <small> {toast.time} </small>
        </div>
      </ListGroupItem>
    );
  });

const emptyToasts = () => {
  return (
    <p style={{ 'textAlign': 'center', 'paddingTop': '8px' }}>
      No recent toasts.
    </p>
  );
};

export default RecentToastsComponent;


// WEBPACK FOOTER //
// src/Components/RecentToastsComponent.jsx